import { FC } from "react";
import { useSelector } from "react-redux";
import TableTab from "../../../components/tabs/table-tab";
import { REPORTS_HOLIDAYS } from "../../../constants/menu-types";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { DEF_PG_SIZE_REPORTS } from '../../../constants/maximum-page-size';
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import HolidayColumns from "../../../models/ColumnDefinitions/HolidayColumns";
import { Lookup } from "../../../models/Lookup";
import LookupTypes from "../../../models/LookupTypes";
import HolidaySearch from "../../../models/search/HolidaySearch";
import { auditRunReport } from "../../../services/auditService";
import { getHolidays } from "../../../services/holidaysService";
import { getSiteNamesWithPagination } from "../../../services/siteService";
import { getErrorMessage } from "../../../services/utilities/ServiceError";

interface HolidayReportProps {
    reportId: string;
}

const HolidayReport: FC<HolidayReportProps> = ({ reportId }) => {
    const { translate } = useLocale();
    const lookup: Lookup[] = [
        {
            name: LookupTypes.holidayReportSite,
            values: [],
            dataMethod: getSiteNamesWithPagination,
            searchAccessor: HolidayColumns.find(column => column.accessor === "site")?.searchOnName
        }
    ];

    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const currentMenuDetail = REPORTS_HOLIDAYS;
    const initialiseUserPreferences = (setDetails: (userLoginId, currentMenuDetail, [], reportId) => void) => {
        setDetails(userLoginId, currentMenuDetail, [], reportId);
    }
    // <-- end context

    const getDataMethod = async (listParameters?: any) => {
        try {
            await auditRunReport(reportId);
            return getHolidays(listParameters);
        } catch (error) {
            return Promise.reject(getErrorMessage(error));
        }
    }

    return (<TableContextProvider
        maxPageSize={DEF_PG_SIZE_REPORTS}
        dataMethod={getDataMethod}
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        tableDescriptor={HolidayColumns}
        searchDescriptor={HolidaySearch}
        useFilter
        useSort
        usePagination
        useSearch
        useTable
        lookup={lookup}
        loadDataOnDemand
        runDataOnDemandButtonLabel={translate.byKey(TranslationKeys.runReport)}>
        <TableTab
            title={''}
            reportTitle={translate.byKey(TranslationKeys.holidays)}
            selectRows={false}
            cyName="holidayReport"/>
    </TableContextProvider >
    );
};

export default HolidayReport;
